import { apiSlice } from './apiSlice';

export interface LagnaLord {
  planet: string;
  lordShipHouse: string;
}

export interface LagnaLordsResponse {
  id: string;
  lagna: string;
  lords: LagnaLord[];
}

export const lagnaLordsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getLagnaLords: builder.query<LagnaLordsResponse, string | null>({
      query: (userId) => ({
        url: '/astrology/lagna-loards',
        method: 'GET',
        params: { userId },
      }),
    }),
  }),
});

export const { useGetLagnaLordsQuery } = lagnaLordsApi;
